import { SnackbarProps, snackbarType, useGlobalNotification } from 'hooks/useGlobalNotification';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export const useSnackbar = () => {
  const { t } = useTranslation();
  const { displaySnackbar } = useGlobalNotification();

  const defaultSnackbar = (props?: SnackbarProps | MouseEventHandler) => {
    const {
      type = snackbarType.success,
      message,
      onClick,
    } = typeof props === 'object' && props !== null ? props : { type: snackbarType.success };

    const result = {
      message: message || t(`messages:${type}.message`),
    };

    displaySnackbar({
      message: result.message as string,
      type,
      onClick,
    });
  };

  return {
    defaultSnackbar,
  };
};
